import React from 'react';
import Login from '../components/auth/Login';
import Register from '../components/auth/Register';
import { Route, Routes } from 'react-router-dom';
import ForgotPassword from '../components/auth/ForgotPassword';

const Auth = () => {
    return (
        <div className='py-5 bg-gray-200'>
            <div className="container mx-auto md:px-5">
                <Routes>
                    <Route path="/*" element={<Login />}></Route>
                    <Route path="register" element={<Register />}></Route>
                    <Route path="forget-password" element={<ForgotPassword />}></Route>
                </Routes>
            </div>
        </div>
    );
};

export default Auth;